/**
 * Data structure for a Game ID
 */
define('gid-decoder/GidDecoder',['require','exports','module'],function(require, exports, module) {
	var data;

	exports.decodeGID = function($data) {
		data = $data + "";
		if (data.length == 26 || data.length == 30) {
			if (data.length == 30) {
				data = data.substr(4, 30);
			}

			return parseGID();
		} else if (!isNaN(parseFloat(data)) || data.indexOf("pk_") >= 0) {
			if (data.indexOf("pk_") >= 0) {
				data = data.substr(3);
			}

			return parseGPK();

		} else {

			throw new Error("the game id handed over does not seem to be valid length, pardner.");

		}

		return null;
	};

	function parseGPK() {
		return {
			format: "pk",
			pk: data,
			storeVal: "pk_" + data,
			displayVal: parseFloat(data)
		}
	}

	function parseGID() {
		var gid = ((data.split("/").join("_") ).split("-") ).join("_").substring((data.length === 26) ? 0 : 4),
			gidSplit = gid.split("_"),
			year = gidSplit[0],
			month = gidSplit[1],
			day = gidSplit[2],
			away_full_code = gidSplit[3],
			home_full_code = gidSplit[4],
			gid_path = "gid_" + gid;

		return {
			format: "gid",
			gid: gid,
			gid_path: "gid_" + gid,
			year: year,
			month: month,
			day: day,
			away_full_code: away_full_code,
			away_team_code: away_full_code.substr(0,3),
			away_sport_code: away_full_code.substr(3,6),
			home_full_code: home_full_code,
			home_team_code: home_full_code.substr(0,3),
			home_sport_code: home_full_code.substr(3,6),
			product_code: home_full_code.substr(3,6),
			gamenumber: gidSplit[5],
			gameDateString: (function () { return month + "/" + day + "/" + year; })(),
			dateFormat: [month, day, away_full_code, home_full_code],

			storeVal: gid_path,
			displayVal: gid,

			isValid: (function () {
				if (data.length !== 26 && data.length !== 30) {
					return false;
				} else {
					return !(isNaN(parseFloat(this.year)) || isNaN(parseFloat(this.month)) || isNaN(parseFloat(this.day)) || isNaN(parseFloat(gidSplit[6])));
				}
			}())
		}
	}
});
